export const contacts=[
    {
        name:"Mathew Davis",
        position:"Chairperson",
        email:"mathewdavis.mec@gmail.com",
        linkedin:"https://www.linkedin.com/in/mathew-davis-855002211/",
        phno:"+919496573224"
    },
    {
        name:"Vishnu S",
        position:"General Secretary",
        email:"vishnusarath.mec@gmail.com",
        linkedin:"https://www.linkedin.com/in/vishnu-s-89300920b/",
        phno:"+917736897653"
    },
    {
        name:"Abhishek P",
        position:"Joint Secretary",
        email:"abhishekp007.mec@gmail.com",
        linkedin:"https://www.linkedin.com/in/abhishek-p-6b2336214/",
        phno:"+917025715130"
    },
    {
        name:"Achyuth Mohan",
        position:"Web Manager",
        email:"achyuthmohan.mec@gmail.com",
        linkedin:"https://www.linkedin.com/in/achyuth-mohan",
        phno:"+917034073339"
    },
    {
        name:"Mayon Francis",
        position:"CS Tech Manager",
        email:"mayonfrancis.mec@gmail.com",
        linkedin:"https://www.linkedin.com/in/mayon-francis/",
        phno:"+917034452171"
    },
]